import { Component, computed, EventEmitter, Output } from '@angular/core';
import { earningsAnalysisData } from '../services/earnings-analysis-data';
import { EpsChart } from '../eps-chart/eps-chart';
import { V3OverviewCardHeader } from '../v3-overview-card-header/v3-overview-card-header';
import { V3EarningsDesktopContent } from '../v3-earnings-desktop-content/v3-earnings-desktop-content';
import { formatReportPeriod } from '../earnings-data';

// V3 main page's "Earnings" card — restyles V2's EarningsOverview (earnings_report). See CLAUDE.md.
@Component({
  selector: 'app-v3-earnings-overview',
  imports: [EpsChart, V3OverviewCardHeader, V3EarningsDesktopContent],
  standalone: true,
  templateUrl: './v3-earnings-overview.html',
  styleUrl: './v3-earnings-overview.scss',
})
export class V3EarningsOverview {
  private readonly data = earningsAnalysisData();

  @Output() navigate = new EventEmitter<void>();

  // finnetApp is mobile-only regardless of viewport width (e.g. iPad) — isDesktop excludes it.
  readonly isFinnet = this.data.isFinnet;
  readonly isDesktop = this.data.isDesktop;

  readonly updatedAt = this.data.updatedAt;

  // Finnet-only subtitle, e.g. "Earnings-Ergebnis Q1 26" — same V2 helper EarningsOverview uses.
  readonly reportPeriod = computed(() => formatReportPeriod(this.data.earningsAnalysis()?.content));

  // Highlight title below the mobile chart.
  readonly earningsTitle = this.data.title;

  readonly epsData = this.data.epsData;

  // The card's only mobile content is the chart, so there's nothing to show without it.
  readonly visible = computed(() => !!this.epsData());

  onNavigate() {
    this.navigate.emit();
  }
}
